// extracted by mini-css-extract-plugin
module.exports = {"Badge":"RiveBadge_Badge__F9ONI","BadgePrimary":"RiveBadge_BadgePrimary__QwS8a","BadgeStandard":"RiveBadge_BadgeStandard__aD2_z"};